import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'builders-liability',
  templateUrl: './builders-liability.component.html',
  styleUrls: ['./builders-liability.component.scss']
})
export class BuildersLiabilityComponent implements OnInit {
  summaryPanel;
  get summaryAPIData() {
    return this.summaryPanel;
  }
  @Input() set summaryAPIData(value) {
    this.summaryPanel = { ...value };
  }
  @Input() summarySitecoreData;
  @Input() pageName;

  constructor() {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
}
